import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="" align="center">
                                            <img alt="" style={{maxWidth:'100%'}}
                                                 src={require('@images/how to be innovative.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>What do you see in the image to the right?</p>
                                            <div className="border_subtitle"><img
                                                src={require('@images/green-apple.jpg')}
                                                align="right" alt=""/>Just an apple?
                                            </div>
                                            <p>To most people, this is just an apple. However, to one
                                                exceptional scientist it was the inspiration for the
                                                greatest leap forward in physics since the Ancient Greeks.
                                                Whilst the story of Newton’s apple might just be anecdotal,
                                                it serves to explain that even the most subtle cues can be
                                                the source of the most creative and innovative ideas. To
                                                explain further, the classic psychological experiment below
                                                shows how great ideas can be born from the most inauspicious
                                                starts.</p>
                                            <br/>
                                            <div className="lightgreencontentbg">
                                                <div className="border_subtitle">Monkey-ing around</div>
                                                <p>If you’ve ever seen chimpanzees at a zoo, you might
                                                    be aware of their tendency to behave in a cheeky
                                                    manner. However, to psychologists, this unruly
                                                    behaviour can be indicative of a much more complex
                                                    psychological premise. And due to our evolutionary
                                                    closeness to chimpanzees, this makes it all the more
                                                    relevant to our understanding of the human mind.</p>
                                                <p>
                                                    A 2010 study<a className="superscripttext"
                                                                   href="further_info.php?course=300"><sup>1</sup></a> into
                                                    chimpanzees kept in a zoo in Sweden focused on the
                                                    questionable actions of Sandino, a Bonobo chimp.
                                                    Sandino was fond of throwing rocks and other objects
                                                    at the visitors to the zoo who disturbed his
                                                    peaceful existence. In an effort to stop this, the
                                                    zoo keepers removed any throwable objects during
                                                    visiting times. This was not enough, however, to
                                                    stop Sandino, who had learnt to hide objects under
                                                    hay and other materials, ready for the visitors’
                                                    arrival.</p>

                                                <div className="uiheading"><p>It was known before this
                                                    study that intelligent animals such as chimps are
                                                    able to display forward planning such as this. But
                                                    critically, this behaviour was self-generated and
                                                    not the process of a labratory-based study, in which
                                                    Sandino was being conditioned into a desired
                                                    behaviour. Additionally, Sandino had not copied this
                                                    behaviour from another chimp or human; it was a
                                                    truly innovative behaviour. This means chimpanzees
                                                    have the ability to spontaneously generate
                                                    innovative ideas to achieve an aim.</p></div>

                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}